//imports
import {
    SIM_PROVIDER_ACCOUNT_CREATE_EDIT_OPEN_MODAL,
    SIM_PROVIDER_ACCOUNT_CREATE_REQUEST,
    SIM_PROVIDER_ACCOUNT_CREATE_RESULT,
    SIM_PROVIDER_ACCOUNT_EDIT_REQUEST,
    SIM_PROVIDER_ACCOUNT_EDIT_RESULT,
    SIM_PROVIDER_ACCOUNT_GET_REQUEST,
    SIM_PROVIDER_ACCOUNT_GET_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    simProviderAccount: null,
    current: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SIM_PROVIDER_ACCOUNT_GET_REQUEST:
            return { ...state, loading: true }

        case SIM_PROVIDER_ACCOUNT_GET_RESULT:
            return { ...state, loading: false, simProviderAccount: action.payload }

        case SIM_PROVIDER_ACCOUNT_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, current: action.payload.data }

        case SIM_PROVIDER_ACCOUNT_CREATE_REQUEST:
            return { ...state, loading: true }

        case SIM_PROVIDER_ACCOUNT_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case SIM_PROVIDER_ACCOUNT_EDIT_REQUEST:
            return { ...state, loading: true }

        case SIM_PROVIDER_ACCOUNT_EDIT_RESULT:
            return { ...state, loading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "SIM_PROVIDER_ACCOUNT_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};